import { BookingPassEntity } from '@resident-select/domain/booking-pass';
import { createEntityEvent } from '../../../shared/base';
import { createAction, props } from '@ngrx/store';
import { BookingEntity } from '@resident-select/domain/booking';

export const CreatedBookingPassEvent =
  createEntityEvent<BookingPassEntity>('CreatedBookingPassEvent');

export const FilteredBookingPassesDomainEvent = createAction(
  'FilteredBookingPassesDomainEvent',
  props<{
    transactionId: string;
    data: {
      booking: BookingEntity;
      bookingPasses: BookingPassEntity[];
    }[];
  }>(),
);

export const UpdatedBookingPassDomainEvent = createAction(
  'UpdatedBookingPassDomainEvent',
  props<{
    bookingPass: BookingPassEntity;
  }>(),
);
